module.exports = __webpack_public_path__ + "static/sample-projects-1-504f582d5d72d1226b6ca38ce449b3d5.png";